import { membershipDescriptionFor } from 'groups/lib/groupDisplay';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar';
// @ts-ignore
import GroupCreateModal from 'groups/components/GroupCreateModal';
import GroupName from 'groups/components/GroupName';
import Groups from 'collections/Groups';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import ModalTrigger from 'components/ModalTrigger';
import PropTypes from 'prop-types';
import * as React from 'react';
import ScrollableArea from 'components/ScrollableArea';
import Text from 'components/Text';

import './styles/GroupSelectionDialog.scss';

type Props = {
  groups: Groups | Group[],
  onSelect: (group: Group) => void
  onRequestHide?: () => void,
  title: string,
  emptyMessage: string,
};

class GroupSelectionDialog extends React.Component<Props> {
  static defaultProps = {
    onSelect: (group: Group) => {},
  };

  renderAddGroupOption = () => {
    const dialog = <GroupCreateModal onCreate={this.props.onSelect} onRequestHide={() => {}} />;

    return (
      <ModalTrigger modal={dialog}>
        <li className="GroupSelectionDialog-addGroupItem">
          <Link
            className="GroupSelectionDialog-addGroupItem-link"
            data-test-selector="group-selection-dialog-add-group-option"
            eventElementName="GroupSelectionDialog-addGroupItem-link">
            <Text size="xsmall" weight="semibold">
              Create a class
            </Text>
          </Link>
        </li>
      </ModalTrigger>
    );
  };

  renderGroupOption = (group: Group) => {
    const subscribersCount = membershipDescriptionFor(group);

    const groupCodeOpt = !group.isStaffClass() && (
      <Text className="GroupSelectionDialog-groupItem-code" color="thunder">
        @{group.getCodeOrError()}
      </Text>
    );

    return (
      <li key={group.id} className="GroupSelectionDialog-groupItem">
        <Link
          className="GroupSelectionDialog-groupItem-link"
          data-test-selector={`group-selection-dialog-add-group-item-${group.id}`}
          onClick={() => this.props.onSelect(group)}
          eventElementName="GroupSelectionDialog-groupItem-link">
          <MediaObject center figure="right">
            <MediaObject center figure="left" gutter="small">
              <GroupAvatar className="GroupSelectionDialog-groupItem-avatar" group={group} />
              <div>
                <Text className="GroupSelectionDialog-groupItem-name" truncate>
                  <GroupName group={group} />
                </Text>
                {groupCodeOpt}
              </div>
            </MediaObject>
            <Text className="GroupSelectionDialog-groupItem-count" color="thunder" size="xxsmall">
              {subscribersCount}
            </Text>
          </MediaObject>
        </Link>
      </li>
    );
  };

  renderNoGroups = () => {
    return <li className="GroupSelectionDialog-emptyMessage">{this.props.emptyMessage}</li>;
  };

  render() {
    const { groups } = this.props;
    const groupsArray = groups instanceof Groups ? groups.toArray() : groups;

    return (
      <Dialog
        eventScreenName="GroupSelectionDialog"
        {...this.props}
        className="GroupSelectionDialog"
        size="small">
        <BoxBody className="GroupSelectionDialog-body" divided full>
          <ScrollableArea
            className="GroupSelectionDialog-scrollArea"
            showShadows
            useBodyChildrenHeight>
            <ul className="GroupSelectionDialog-list">
              {groupsArray.length === 0 && this.renderNoGroups()}
              {this.renderAddGroupOption()}
              {groupsArray.map((group: Group) => this.renderGroupOption(group))}
            </ul>
          </ScrollableArea>
        </BoxBody>
      </Dialog>
    );
  }
}

export default GroupSelectionDialog;
